import Backbone from 'backbone';

import { getFirebaseEventHub } from 'zoomforth_zf/appglobals/firebase-event-hub.js';
import Permissions from './permissions.js';

export const PERM_GROUP_ID_ACCOUNT_ADMIN = 1;
export const PERM_GROUP_ID_CONTENT_ADMIN = 2;
export const PERM_GROUP_ID_EDITOR = 3;
export const PERM_GROUP_ID_AUTHOR = 4;
export const PERM_GROUP_ID_SENDER = 6;
export const PERM_GROUP_ID_DESIGNER = 7;

export const PERM_GROUP_DISPLAY_NAME_BY_GROUP_ID = {
  [PERM_GROUP_ID_ACCOUNT_ADMIN]: 'Account Administrator',
  [PERM_GROUP_ID_CONTENT_ADMIN]: 'Content Administrator',
  [PERM_GROUP_ID_EDITOR]: 'Editor',
  [PERM_GROUP_ID_AUTHOR]: 'Author',
  [PERM_GROUP_ID_DESIGNER]: 'Designer'
};

const User = Backbone.Model.extend({
  urlRoot: '/api/users',
  
  initialize: function(attrs, { permissionDefs }) {
    this.permissionDefs = permissionDefs;
  },
  
  getPermissions: function(){
    var permissionInfo = this.permissionDefs[this.get('permission_group')];
    return new Permissions(permissionInfo, { zfUser: this });
  },

  getIsZoomforthSuperuser() {
    return !!this.get('is_zoomforth_superuser');
  },

  isAccountAdminRole: function(){
    return this.get('permission_group') === 1;
  },

  isContentAdminRole: function(){
    return this.get('permission_group') === 2;
  },

  isEditorRole: function(){
    return this.get('permission_group') === 3;
  },

  isAuthorRole: function(){
    return this.get('permission_group') === 4;
  },

  isSenderRole: function(){
    return this.get('permission_group') === 6;
  },
  
  canViewAllPages: function(){
    // proxying to the permissions object, for backwards compatability while refactoring
    return this.getPermissions().canViewAllPages();
  },
  
  isInvited: function() {
    // the user_level 2 is STATUS_USER_INVITED
    return (this.get('user_level') == 2);
  },

  isSupportUser() {
    return this.get('is_support_user');
  },
  
  getRoleName() {
    return PERM_GROUP_DISPLAY_NAME_BY_GROUP_ID[this.get('permission_group')];
  },

  getDisplayableName: function() {
    var emailStr = this.get('email') ? `(${this.get('email')})` : '';
    return [this.getFirstName(), this.getLastName(), emailStr].join(' ');
  },
  
  getFirstName: function() {
    if(!this.get('name')) {
      return '';
    } else {
      return this.get('name').split(' ')[0];
    }
  }, 
  
  getLastName: function() {
    if(!this.get('name')) {
      return '';
    } else {
      var names = this.get('name').split(' ');
      names.shift();
      if(names.length) {
        return names.join(' '); 
      }
    }
  },

  getApprovalRequestNotificationsSetting: function() {
    return this.get('approval_request_notifications_setting');
  },

  getPageAssignmentNotificationsSetting: function() {
    return this.get('page_assignment_notifications_setting');
  },

  getAccessRequestNotificationsSetting: function() {
    return this.get('access_request_notifications_setting');
  },

  getLinkVisitNotificationsSetting: function() {
    return this.get('link_visit_notifications_setting');
  },

  getPromptResponseNotificationsSetting: function() {
    return this.get('prompt_response_notifications_setting');
  },

  getFormResponseNotificationsSetting: function() {
    return this.get('form_response_notifications_setting');
  }

});


User.init = function(userData, { permissionDefs }) {

  var user;
  if (userData){
    user = new User(userData, { permissionDefs });
  }

  getFirebaseEventHub().on('user-logout', ({ user_id, redirect_location })=> {
    if (user && user.get('id') == user_id) { 
      window.setTimeout(function() {
        window.location = redirect_location;
      }, 750);
    }
  });

  return user;
};

export default User;
